import { COMPANY_TYPE_QUESTION, type CompanyType } from '@wtta/scoring'

interface CompanyTypeStepProps {
  onSelect: (type: CompanyType) => void
}

export function CompanyTypeStep({ onSelect }: CompanyTypeStepProps) {
  return (
    <section className="wtta-step wtta-step--company-type" data-testid="company-type-step">
      <h2 className="wtta-title">{COMPANY_TYPE_QUESTION.question}</h2>
      {COMPANY_TYPE_QUESTION.helpText ? (
        <p className="wtta-help">{COMPANY_TYPE_QUESTION.helpText}</p>
      ) : null}
      <div className="wtta-options">
        {COMPANY_TYPE_QUESTION.options.map((option) => (
          <button
            key={option.value}
            type="button"
            className="wtta-option"
            data-testid={`company-type-${option.value}`}
            onClick={() => onSelect(option.value as CompanyType)}
          >
            <span className="wtta-option__label">{option.label}</span>
          </button>
        ))}
      </div>
    </section>
  )
}
